import { render, staticRenderFns } from "./ListsQuickButtons.vue?vue&type=template&id=3a049484&"
import script from "./ListsQuickButtons.vue?vue&type=script&lang=js&"
export * from "./ListsQuickButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a049484')) {
      api.createRecord('3a049484', component.options)
    } else {
      api.reload('3a049484', component.options)
    }
    module.hot.accept("./ListsQuickButtons.vue?vue&type=template&id=3a049484&", function () {
      api.rerender('3a049484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/sitecontent/ListsQuickButtons.vue"
export default component.exports